export default (src: string): boolean => {
  if (!src) return false
  const scripts = document.getElementsByTagName('script')

  for (let i: number = scripts.length; i--; ) {
    if (scripts[i].src === src) return true
  }

  return false
}
